const it = {
    MinimumLength: 'Minimo {num} caratteri',
    RequireNumbers: 'Un numero',
    RequireSymbols: 'Un simbolo',
    RequireLowercase: 'Una lettera minuscola',
    RequireUppercase: 'Una lettera maiuscola',
};

export default it;
